<template>
  <div>
     <!-- 新增的顶部标题栏 -->
  <div class="header">
    <div class="logo">华阳客户查询系统</div>
    <div class="header-right">
            <div class="header-user-con">
                <!-- 全屏显示 -->
                <!-- <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div> -->
                
                <!-- 用户头像 -->
                <div class="user-avator">
                    <img src="../../assets/images/img.jpg" />
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{username}}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <a href="https://github.com/lin-xin/vue-manage-system" target="_blank">
                            <el-dropdown-item>项目仓库</el-dropdown-item>
                        </a> -->
                        <router-link class="inlineBlock" to="/">
                          <el-dropdown-item>
                            首页
                          </el-dropdown-item>
                        </router-link>
                        <!-- <el-dropdown-item divided command="updatePassword">首页</el-dropdown-item> -->
                        <el-dropdown-item divided command="loginout">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
  </div>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import {setSupport,getSupport,setCookie,getCookie} from '@/utils/support';

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    username() {
      return this.$store.state.user.name
    }
  },
  methods: {
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                // localStorage.removeItem('ms_username');
                // this.$router.push('/login');
                 this.$store.dispatch('LogOut').then(() => {
                    location.reload() // 为了重新实例化vue-router对象 避免bug
                })
            } 
        },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }

  /* 新增的顶部标题栏样式 - 覆盖整个页面宽度 */
  // .top-title-bar {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   width: 100%;
  //   height: 70px;
  //   background-color: #242f42;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   z-index: 1002; /* 提高层级，确保在侧边栏之上 */
  // }

  // .top-title-text {
  //  float: left;
  //   width: 250px;
  //   line-height: 70px;
  // }

  .header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    background-color: #242f42;
    color: #fff;
}
// .collapse-btn {
//     float: left;
//     padding: 0 21px;
//     cursor: pointer;
//     line-height: 70px;
// }
.header .logo {
    float: left;
    padding: 0 21px;
    width: 250px;
    line-height: 70px;
}

.header-right {
    float: right;
    padding-right: 50px;
}
.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}
  
  /* 为整个布局添加顶部内边距，避免内容被标题栏遮挡 */
  .app-wrapper {
    box-sizing: border-box;
  }
  
  /* 确保侧边栏也正确偏移，不被标题栏遮挡内容 */
  .sidebar-container {
    margin-top: 70px !important;
    height: calc(100%) !important;
  }

.user-name {
    margin-left: 10px;
}
.user-avator {
    margin-left: 20px;
}
.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 20%;
}
.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}
  
  
</style>
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue